import { Link } from 'react-router-dom';

import familyStyles from './familyInformationPage.module.scss';

interface MemberBlockProps {
    memberName: string;
    isHovedmedlem: boolean;
    isBarn: boolean;
    index?: number;
}

export default function MemberBlock({ memberName, isHovedmedlem, isBarn, index }: MemberBlockProps) {
    const childId = index ? index + 1 : 1;

    const editLink = isHovedmedlem ? 'hoved' : isBarn ? `barn/${childId}` : 'partner';

    const memberTitle = isHovedmedlem ? 'Hovedmedlem' : isBarn ? 'Barn' : 'Ektefelle/samboer';

    return (
        <div
            className={
                isHovedmedlem ? familyStyles.mainMember : isBarn ? familyStyles.memberChild : familyStyles.member
            }
        >
            <div className={familyStyles.memberInfo}>
                <div className={familyStyles.memberTitle}>{memberName}</div>
                <div className={familyStyles.memberType}>{memberTitle}</div>
            </div>
            <div>
                <Link to={editLink} className={familyStyles.btnChangeItem}>
                    Endre
                </Link>
            </div>
        </div>
    );
}
